export const FIELD_DATA = '_field_data';
// Mock data for language tabs
export const MOCK_TABS = [
    {id: '1', title: 'English'},
    {id: '2', title: 'Hebrew'}
];

// Mock data for dropdown
export const MOCK_CHOOSE_DROPDOWN = [
    {label: 'test', value: 'test'},
    {label: 'test2', value: 'test2'},
    {label: 'test3', value: 'test3'},
    {label: 'test4', value: 'test4'},
    {label: 'test5', value: 'test5'},
    {label: 'test6', value: 'test6'},
    {label: 'test7', value: 'test7'},
    {label: 'test8', value: 'test8'}
];

export const MOCK_BRANCHES_DATA = [
    {
        title: 'Sales Orders',
        id: '24654-445',
        isMain: true,
        nodes: [
            {
                title: 'Order Item',
                id: 'dsg-hef',
                nodes: [
                    {
                        title: 'Contacts',
                        id: 'sfeii-53',
                        nodes: [
                            {
                                id: 'dgh-dtg-56',
                                title: 'Contact Details',
                                nodes: []
                            }
                        ]
                    },
                    {
                        title: 'Inventory',
                        id: 'hee7802',
                        nodes: []
                    },
                    {
                        title: 'Price Quotation for Customers',
                        id: '378dsj-676',
                        nodes: []
                    },
                    {
                        title: 'Prod. Planning Group',
                        id: 'sge7jds82',
                        nodes: []
                    }
                ]
            }
        ]
    },
    {
        title: 'Customers',
        id: '3hds837',
        isMain: true,
        nodes: [
            {
                title: 'Contacts',
                id: '732hedy3',
                nodes: [
                    {
                        title: 'Contact Details',
                        id: 'eydudndy',
                        nodes: []
                    }
                ]
            }
        ]
    },
    {
        title: 'History of Order Item Statuses',
        id: '3h7dh35',
        isMain: true,
        nodes: [
            {
                title: 'Log',
                id: '32ud73',
                nodes: []
            }
        ]
    }
];

export const MOCK_FORM_TREE_RESPONSE = {
    Form: [
        {
            Name: 'CUSTOMERS',
            Title: 'Customers',
            Id: '4',
            Form: [
                {
                    Name: 'CUSTOMERSA',
                    Title: 'Additional Customer Data',
                    Id: '157084733',
                    Form: [],
                    Field: [
                        {
                            Name: 'CUSTOMERSA.SEMARKUPP',
                            Title: 'Shipping Markup (%)',
                            Id: '157084733:SEMARKUPP'
                        },
                        {
                            Name: 'CUSTOMERSA.STATEA',
                            Title: 'City/State (Lang 2)',
                            Id: '157084733:STATEA'
                        },
                        {
                            Name: 'CUSTOMERSA.ADDRESSA',
                            Title: 'Address (Lang 2)',
                            Id: '157084733:ADDRESSA'
                        },
                        {
                            Name: 'CUSTOMERSA.SEMARKUPA',
                            Title: 'Shipping Markup(Amt)',
                            Id: '157084733:SEMARKUPA'
                        },
                        {
                            Name: 'CUSTOMERSA.MAILINTERFACE',
                            Title: 'Allow Data Exchange?',
                            Id: '157084733:MAILINTERFACE'
                        },
                        {
                            Name: 'CUSTOMERSA.USERLOGIN',
                            Title: 'Technician in Charge',
                            Id: '157084733:USERLOGIN'
                        },
                        {
                            Name: 'CUSTOMERSA.CARRIERCHARGE',
                            Title: 'Carrier Charge',
                            Id: '157084733:CARRIERCHARGE'
                        },
                        {
                            Name: 'CUSTOMERSA.USERLOGIN2',
                            Title: 'Signature',
                            Id: '157084733:USERLOGIN2'
                        },
                        {
                            Name: 'CUSTOMERSA.HOSTNAME',
                            Title: "Customer's Web Site",
                            Id: '157084733:HOSTNAME'
                        },
                        {
                            Name: 'CUSTOMERSA.EXTFILENAME',
                            Title: "Customer's Logo",
                            Id: '157084733:EXTFILENAME'
                        },
                        {
                            Name: 'CUSTOMERSA.UDATE',
                            Title: 'Time Stamp',
                            Id: '157084733:UDATE'
                        },
                        {
                            Name: 'CUSTOMERSA.MSVNUM',
                            Title: 'ITP Number',
                            Id: '157084733:MSVNUM'
                        },
                        {
                            Name: 'CUSTOMERSA.REMARKS',
                            Title: 'Remarks',
                            Id: '157084733:REMARKS'
                        },
                        {
                            Name: 'CUSTOMERSA.PAYCUSTNAME',
                            Title: "Cust's# at Bill Cust",
                            Id: '157084733:PAYCUSTNAME'
                        },
                        {
                            Name: 'CUSTOMERSA.MYNUM',
                            Title: 'My Vendor No at Cust',
                            Id: '157084733:MYNUM'
                        },
                        {
                            Name: 'CUSTOMERSA.SECURRCODE',
                            Title: 'Markup Currency',
                            Id: '157084733:SECURRCODE'
                        }
                    ]
                },
                {
                    Name: 'CUSTMSG',
                    Title: 'Cust. Remarks for Internal Use',
                    Id: '157084746',
                    Form: [],
                    Field: [
                        {
                            Name: 'CUSTMSG.TEXT1',
                            Title: 'Ln 1 of Remark',
                            Id: '157084746:TEXT1'
                        },
                        {
                            Name: 'CUSTMSG.TEXT2',
                            Title: 'Ln 2 of Remark',
                            Id: '157084746:TEXT2'
                        },
                        {
                            Name: 'CUSTMSG.TEXT3',
                            Title: 'Ln 3 of Remark',
                            Id: '157084746:TEXT3'
                        }
                    ]
                },
                {
                    Name: 'H_FINDZIP',
                    Title: 'Find Zip Codes in Israel',
                    Id: '157084741',
                    Form: [],
                    Field: [
                        {
                            Name: 'H_FINDZIP.ENTRY',
                            Title: 'Entrance',
                            Id: '157084741:ENTRY'
                        },
                        {
                            Name: 'H_FINDZIP.ZIPCODE',
                            Title: 'Zip Code',
                            Id: '157084741:ZIPCODE'
                        },
                        {
                            Name: 'H_FINDZIP.STREETNAME',
                            Title: 'Street Name',
                            Id: '157084741:STREETNAME'
                        },
                        {
                            Name: 'H_FINDZIP.NUM',
                            Title: 'Address',
                            Id: '157084741:NUM'
                        },
                        {
                            Name: 'H_FINDZIP.STREETCODE',
                            Title: 'Street',
                            Id: '157084741:STREETCODE'
                        },
                        {
                            Name: 'H_FINDZIP.POBNUM',
                            Title: 'P.O. Box',
                            Id: '157084741:POBNUM'
                        },
                        {
                            Name: 'H_FINDZIP.CITYCODE',
                            Title: 'City',
                            Id: '157084741:CITYCODE'
                        },
                        {
                            Name: 'H_FINDZIP.CITYZIP',
                            Title: 'Zip Code of City',
                            Id: '157084741:CITYZIP'
                        },
                        {
                            Name: 'H_FINDZIP.CITYNAME',
                            Title: 'Name of City',
                            Id: '157084741:CITYNAME'
                        }
                    ]
                },
                {
                    Name: 'SEARCHDOCVERS',
                    Title: 'Last Updated - Docs',
                    Id: '180738301',
                    Form: [],
                    Field: [
                        {
                            Name: 'SEARCHDOCVERS.DOCGUID',
                            Title: 'Document ID',
                            Id: '180738301:DOCGUID'
                        },
                        {
                            Name: 'SEARCHDOCVERS.LASTUPDATE',
                            Title: 'Date Modified',
                            Id: '180738301:LASTUPDATE'
                        }
                    ]
                },
                {
                    Name: 'DOCTODOLIST',
                    Title: 'To Do Item',
                    Id: '157292709',
                    Form: [],
                    Field: [
                        {
                            Name: 'DOCTODOLIST.FROMDATE',
                            Title: 'Start Date',
                            Id: '157292709:FROMDATE'
                        },
                        {
                            Name: 'DOCTODOLIST.OWNERLOGIN',
                            Title: 'Assigned to',
                            Id: '157292709:OWNERLOGIN'
                        },
                        {
                            Name: 'DOCTODOLIST.TODOLIST',
                            Title: 'Item Number',
                            Id: '157292709:TODOLIST'
                        },
                        {
                            Name: 'DOCTODOLIST.DETAILS',
                            Title: 'Details',
                            Id: '157292709:DETAILS'
                        },
                        {
                            Name: 'DOCTODOLIST.FOLLOWUPDETAILS',
                            Title: 'Tracking Details',
                            Id: '157292709:FOLLOWUPDETAILS'
                        },
                        {
                            Name: 'DOCTODOLIST.PLANNEDHOURS',
                            Title: 'Planned Hours',
                            Id: '157292709:PLANNEDHOURS'
                        },
                        {
                            Name: 'DOCTODOLIST.INITIATORLOGIN',
                            Title: 'Opened by',
                            Id: '157292709:INITIATORLOGIN'
                        },
                        {
                            Name: 'DOCTODOLIST.TODATE',
                            Title: 'Complete by',
                            Id: '157292709:TODATE'
                        },
                        {
                            Name: 'DOCTODOLIST.PRIO',
                            Title: 'Priority',
                            Id: '157292709:PRIO'
                        },
                        {
                            Name: 'DOCTODOLIST.FOLLOWUPPRIO',
                            Title: 'Tracking Priority',
                            Id: '157292709:FOLLOWUPPRIO'
                        }
                    ]
                }
            ],
            Field: [
                {
                    Name: 'CUSTOMERS.SPEC7',
                    Title: 'Outstanding!',
                    Id: '4:SPEC7'
                },
                {
                    Name: 'CUSTOMERS.COMMISSION',
                    Title: "Rep's Commission (%)",
                    Id: '4:COMMISSION'
                },
                {
                    Name: 'CUSTOMERS.UNLOADTIME',
                    Title: 'Unload Time (Deliv.)',
                    Id: '4:UNLOADTIME'
                },
                {
                    Name: 'CUSTOMERS.ADDRESS2',
                    Title: 'Address (Line 2)',
                    Id: '4:ADDRESS2'
                },
                {
                    Name: 'CUSTOMERS.ECUSTDES',
                    Title: 'Cust. Name (Lang 2)',
                    Id: '4:ECUSTDES'
                },
                {
                    Name: 'CUSTOMERS.ADDRESS3',
                    Title: 'Address (Line 3)',
                    Id: '4:ADDRESS3'
                },
                {
                    Name: 'CUSTOMERS.DISTRTYPEDES',
                    Title: 'Distrib. Type Desc.',
                    Id: '4:DISTRTYPEDES'
                },
                {
                    Name: 'CUSTOMERS.DISTRLINEDES',
                    Title: 'Distrib. Route Desc.',
                    Id: '4:DISTRLINEDES'
                },
                {
                    Name: 'CUSTOMERS.AGENTCODE2',
                    Title: "Add'l Sales Rep No.",
                    Id: '4:AGENTCODE2'
                },
                {
                    Name: 'CUSTOMERS.PCUSTNAME',
                    Title: 'Parent Company No.',
                    Id: '4:PCUSTNAME'
                },
                {
                    Name: 'CUSTOMERS.DCMONTHS',
                    Title: 'Allowed Inv Age-Mos.',
                    Id: '4:DCMONTHS'
                },
                {
                    Name: 'CUSTOMERS.MCUSTNAME',
                    Title: 'Representative Cust.',
                    Id: '4:MCUSTNAME'
                },
                {
                    Name: 'CUSTOMERS.SPEC2',
                    Title: 'p2',
                    Id: '4:SPEC2'
                },
                {
                    Name: 'CUSTOMERS.SPEC8',
                    Title: 'SPEC8',
                    Id: '4:SPEC8'
                },
                {
                    Name: 'CUSTOMERS.SECONDLANGTEXT',
                    Title: 'Printouts in Lang 2?',
                    Id: '4:SECONDLANGTEXT'
                },
                {
                    Name: 'CUSTOMERS.NSFLAG',
                    Title: 'Change Name?',
                    Id: '4:NSFLAG'
                },
                {
                    Name: 'CUSTOMERS.CHANEL',
                    Title: 'Sales Channel?',
                    Id: '4:CHANEL'
                },
                {
                    Name: 'CUSTOMERS.CONFIDENTIAL',
                    Title: 'Secured Customer?',
                    Id: '4:CONFIDENTIAL'
                },
                {
                    Name: 'CUSTOMERS.COMPETITORFLAG',
                    Title: 'Competitor?',
                    Id: '4:COMPETITORFLAG'
                },
                {
                    Name: 'CUSTOMERS.EXTFILEFLAG',
                    Title: 'Attachments?',
                    Id: '4:EXTFILEFLAG'
                },
                {
                    Name: 'CUSTOMERS.BONUSFLAG',
                    Title: 'Gets Regular Bonus?',
                    Id: '4:BONUSFLAG'
                },
                {
                    Name: 'CUSTOMERS.FORECAST',
                    Title: 'Sales/Order Target?',
                    Id: '4:FORECAST'
                },
                {
                    Name: 'CUSTOMERS.VATNUM',
                    Title: 'Federal Tax ID',
                    Id: '4:VATNUM'
                },
                {
                    Name: 'CUSTOMERS.SPEC10',
                    Title: 'TEST',
                    Id: '4:SPEC10'
                },
                {
                    Name: 'CUSTOMERS.CTYPE2NAME',
                    Title: 'Sec. Group Desc',
                    Id: '4:CTYPE2NAME'
                },
                {
                    Name: 'CUSTOMERS.ESTABLISHED',
                    Title: 'Year Established',
                    Id: '4:ESTABLISHED'
                },
                {
                    Name: 'CUSTOMERS.CREATEDDATE',
                    Title: 'Date Opened',
                    Id: '4:CREATEDDATE'
                },
                {
                    Name: 'CUSTOMERS.STDES',
                    Title: 'Shipping Method',
                    Id: '4:STDES'
                },
                {
                    Name: 'CUSTOMERS.WAVESTRATEGYDES',
                    Title: 'Splitting Method',
                    Id: '4:WAVESTRATEGYDES'
                },
                {
                    Name: 'CUSTOMERS.WAVESTRATEGYCODE',
                    Title: 'Task Split Method',
                    Id: '4:WAVESTRATEGYCODE'
                },
                {
                    Name: 'CUSTOMERS.LANG',
                    Title: 'Language Code',
                    Id: '4:LANG'
                },
                {
                    Name: 'CUSTOMERS.ZONECODE',
                    Title: 'Zone Code',
                    Id: '4:ZONECODE'
                },
                {
                    Name: 'CUSTOMERS.STATECODE',
                    Title: 'State Code',
                    Id: '4:STATECODE'
                },
                {
                    Name: 'CUSTOMERS.DISTRLINECODE',
                    Title: 'Distrib. Route Code',
                    Id: '4:DISTRLINECODE'
                },
                {
                    Name: 'CUSTOMERS.BRANCHNAME',
                    Title: 'Branch Code',
                    Id: '4:BRANCHNAME'
                },
                {
                    Name: 'CUSTOMERS.ZIP',
                    Title: 'Zip Code',
                    Id: '4:ZIP'
                },
                {
                    Name: 'CUSTOMERS.CTYPECODE',
                    Title: 'Cust. Group Code',
                    Id: '4:CTYPECODE'
                },
                {
                    Name: 'CUSTOMERS.CTYPE2CODE',
                    Title: 'Secondary Group Code',
                    Id: '4:CTYPE2CODE'
                },
                {
                    Name: 'CUSTOMERS.PAYCODE',
                    Title: 'Payment Terms Code',
                    Id: '4:PAYCODE'
                },
                {
                    Name: 'CUSTOMERS.STCODE',
                    Title: 'Shipment Code',
                    Id: '4:STCODE'
                },
                {
                    Name: 'CUSTOMERS.TAXCODE',
                    Title: 'Tax Code',
                    Id: '4:TAXCODE'
                },
                {
                    Name: 'CUSTOMERS.PICKSTGCODE',
                    Title: 'Pick Strategy Code',
                    Id: '4:PICKSTGCODE'
                },
                {
                    Name: 'CUSTOMERS.TERRITORYCODE',
                    Title: 'Territory Code',
                    Id: '4:TERRITORYCODE'
                },
                {
                    Name: 'CUSTOMERS.QRANKCODE',
                    Title: 'Quality Code',
                    Id: '4:QRANKCODE'
                },
                {
                    Name: 'CUSTOMERS.GPSY',
                    Title: 'Longitude',
                    Id: '4:GPSY'
                },
                {
                    Name: 'CUSTOMERS.GPSX',
                    Title: 'Latitude',
                    Id: '4:GPSX'
                },
                {
                    Name: 'CUSTOMERS.LANGNAME',
                    Title: 'Language',
                    Id: '4:LANGNAME'
                },
                {
                    Name: 'CUSTOMERS.RETURNLABELS',
                    Title: 'Return Label Charge',
                    Id: '4:RETURNLABELS'
                },
                {
                    Name: 'CUSTOMERS.WTAXNUMEXPL',
                    Title: 'Type of Tax File',
                    Id: '4:WTAXNUMEXPL'
                },
                {
                    Name: 'CUSTOMERS.BRANCHDES',
                    Title: 'Branch Name',
                    Id: '4:BRANCHDES'
                },
                {
                    Name: 'CUSTOMERS.AGENTNAME',
                    Title: 'Sales Rep Name',
                    Id: '4:AGENTNAME'
                },
                {
                    Name: 'CUSTOMERS.AGENTNAME2',
                    Title: "Add'l Sales Rep Name",
                    Id: '4:AGENTNAME2'
                },
                {
                    Name: 'CUSTOMERS.CUSTDES',
                    Title: 'Customer Name',
                    Id: '4:CUSTDES'
                },
                {
                    Name: 'CUSTOMERS.CUSTDESLONG',
                    Title: 'Long Customer Name',
                    Id: '4:CUSTDESLONG'
                },
                {
                    Name: 'CUSTOMERS.MCUSTDES',
                    Title: 'Rep Customer Name',
                    Id: '4:MCUSTDES'
                },
                {
                    Name: 'CUSTOMERS.PCUSTDES',
                    Title: 'Parent Company Name',
                    Id: '4:PCUSTDES'
                },
                {
                    Name: 'CUSTOMERS.TERRITORYDES',
                    Title: 'Territory Name',
                    Id: '4:TERRITORYDES'
                },
                {
                    Name: 'CUSTOMERS.DISTRTYPECODE',
                    Title: 'Distribution Type',
                    Id: '4:DISTRTYPECODE'
                },
                {
                    Name: 'CUSTOMERS.SPEC4',
                    Title: 'Something else',
                    Id: '4:SPEC4'
                },
                {
                    Name: 'CUSTOMERS.STATUSDATE',
                    Title: 'Status Update Date',
                    Id: '4:STATUSDATE'
                },
                {
                    Name: 'CUSTOMERS.CUSTNAMEPATNAME',
                    Title: 'Cust No. Template',
                    Id: '4:CUSTNAMEPATNAME'
                },
                {
                    Name: 'CUSTOMERS.STATENAME',
                    Title: 'State',
                    Id: '4:STATENAME'
                },
                {
                    Name: 'CUSTOMERS.STATE',
                    Title: 'City/State',
                    Id: '4:STATE'
                },
                {
                    Name: 'CUSTOMERS.HOSTNAME',
                    Title: 'Web Site',
                    Id: '4:HOSTNAME'
                },
                {
                    Name: 'CUSTOMERS.TRACK',
                    Title: 'Service Route',
                    Id: '4:TRACK'
                },
                {
                    Name: 'CUSTOMERS.INACTIVEFLAG',
                    Title: 'Inactive',
                    Id: '4:INACTIVEFLAG'
                },
                {
                    Name: 'CUSTOMERS.MINEXPDAYS',
                    Title: "Days Until Expirat'n",
                    Id: '4:MINEXPDAYS'
                },
                {
                    Name: 'CUSTOMERS.RESERVFLAG',
                    Title: 'Inventory Allocation',
                    Id: '4:RESERVFLAG'
                },
                {
                    Name: 'CUSTOMERS.ZONEDES',
                    Title: 'Zone Description',
                    Id: '4:ZONEDES'
                },
                {
                    Name: 'CUSTOMERS.CTYPENAME',
                    Title: 'Group Description',
                    Id: '4:CTYPENAME'
                },
                {
                    Name: 'CUSTOMERS.TAXDES',
                    Title: 'Tax Description',
                    Id: '4:TAXDES'
                },
                {
                    Name: 'CUSTOMERS.PICKSTGDES',
                    Title: 'Strategy Description',
                    Id: '4:PICKSTGDES'
                },
                {
                    Name: 'CUSTOMERS.QRANKDES',
                    Title: 'Quality Description',
                    Id: '4:QRANKDES'
                },
                {
                    Name: 'CUSTOMERS.OWNERLOGIN',
                    Title: 'Assigned to',
                    Id: '4:OWNERLOGIN'
                },
                {
                    Name: 'CUSTOMERS.EORINUM',
                    Title: 'EORI Number',
                    Id: '4:EORINUM'
                },
                {
                    Name: 'CUSTOMERS.PHONE',
                    Title: 'Phone Number',
                    Id: '4:PHONE'
                },
                {
                    Name: 'CUSTOMERS.AGENTCODE',
                    Title: 'Sales Rep Number',
                    Id: '4:AGENTCODE'
                },
                {
                    Name: 'CUSTOMERS.CUSTNAME',
                    Title: 'Customer Number',
                    Id: '4:CUSTNAME'
                },
                {
                    Name: 'CUSTOMERS.FAX',
                    Title: 'Fax Number',
                    Id: '4:FAX'
                },
                {
                    Name: 'CUSTOMERS.WTAXNUM',
                    Title: 'Company Number',
                    Id: '4:WTAXNUM'
                },
                {
                    Name: 'CUSTOMERS.PIKORDER',
                    Title: 'Pick Order',
                    Id: '4:PIKORDER'
                },
                {
                    Name: 'CUSTOMERS.DISTRORDER',
                    Title: 'Delivery Order',
                    Id: '4:DISTRORDER'
                },
                {
                    Name: 'CUSTOMERS.EMPNUM',
                    Title: 'Number of Employees',
                    Id: '4:EMPNUM'
                },
                {
                    Name: 'CUSTOMERS.AUTOSHPFLAG',
                    Title: 'AutoShip Pack Crates',
                    Id: '4:AUTOSHPFLAG'
                },
                {
                    Name: 'CUSTOMERS.PAYDES',
                    Title: 'Payment Terms',
                    Id: '4:PAYDES'
                },
                {
                    Name: 'CUSTOMERS.CUSTREMARK',
                    Title: "Cust's Instructions",
                    Id: '4:CUSTREMARK'
                },
                {
                    Name: 'CUSTOMERS.BUSINESSTYPE',
                    Title: 'Type of Business',
                    Id: '4:BUSINESSTYPE'
                },
                {
                    Name: 'CUSTOMERS.EMAIL',
                    Title: 'Email Address',
                    Id: '4:EMAIL'
                },
                {
                    Name: 'CUSTOMERS.ADDRESS',
                    Title: 'Street Address',
                    Id: '4:ADDRESS'
                },
                {
                    Name: 'CUSTOMERS.EDOCUMENTS',
                    Title: 'Receives e-Documents',
                    Id: '4:EDOCUMENTS'
                },
                {
                    Name: 'CUSTOMERS.STATDES',
                    Title: 'Status',
                    Id: '4:STATDES'
                },
                {
                    Name: 'CUSTOMERS.MAX_CREDIT',
                    Title: 'Credit Limit',
                    Id: '4:MAX_CREDIT'
                },
                {
                    Name: 'CUSTOMERS.MAX_OBLIGO',
                    Title: 'Liability Limit',
                    Id: '4:MAX_OBLIGO'
                },
                {
                    Name: 'CUSTOMERS.RECYCLINGFLAG',
                    Title: 'Pays Recycling Tax',
                    Id: '4:RECYCLINGFLAG'
                },
                {
                    Name: 'CUSTOMERS.CODE',
                    Title: 'Billing Currency',
                    Id: '4:CODE'
                },
                {
                    Name: 'CUSTOMERS.OBCODE',
                    Title: 'Credit Currency',
                    Id: '4:OBCODE'
                },
                {
                    Name: 'CUSTOMERS.CUSTPART',
                    Title: 'Ship Cust Parts Only',
                    Id: '4:CUSTPART'
                },
                {
                    Name: 'CUSTOMERS.NOTALLOWFORECAST',
                    Title: 'Cust Forecasts Only',
                    Id: '4:NOTALLOWFORECAST'
                },
                {
                    Name: 'CUSTOMERS.COUNTRYNAME',
                    Title: 'Country',
                    Id: '4:COUNTRYNAME'
                },
                {
                    Name: 'CUSTOMERS.VATCOUNTRYNAME',
                    Title: 'VAT-regist. Country',
                    Id: '4:VATCOUNTRYNAME'
                },
                {
                    Name: 'CUSTOMERS.STATEA',
                    Title: 'City',
                    Id: '4:STATEA'
                },
                {
                    Name: 'CUSTOMERS.SPEC3',
                    Title: 'אורך חדש מאד',
                    Id: '4:SPEC3'
                },
                {
                    Name: 'CUSTOMERS.SPEC11',
                    Title: 'איזור',
                    Id: '4:SPEC11'
                },
                {
                    Name: 'CUSTOMERS.SPEC20',
                    Title: 'איזור10',
                    Id: '4:SPEC20'
                },
                {
                    Name: 'CUSTOMERS.SPEC12',
                    Title: 'איזור2',
                    Id: '4:SPEC12'
                },
                {
                    Name: 'CUSTOMERS.SPEC13',
                    Title: 'איזור3',
                    Id: '4:SPEC13'
                },
                {
                    Name: 'CUSTOMERS.SPEC14',
                    Title: 'איזור4',
                    Id: '4:SPEC14'
                },
                {
                    Name: 'CUSTOMERS.SPEC15',
                    Title: 'איזור5',
                    Id: '4:SPEC15'
                },
                {
                    Name: 'CUSTOMERS.SPEC16',
                    Title: 'איזור6',
                    Id: '4:SPEC16'
                },
                {
                    Name: 'CUSTOMERS.SPEC17',
                    Title: 'איזור7',
                    Id: '4:SPEC17'
                },
                {
                    Name: 'CUSTOMERS.SPEC18',
                    Title: 'איזור8',
                    Id: '4:SPEC18'
                },
                {
                    Name: 'CUSTOMERS.SPEC19',
                    Title: 'איזור9',
                    Id: '4:SPEC19'
                },
                {
                    Name: 'CUSTOMERS.SPEC5',
                    Title: 'גודל',
                    Id: '4:SPEC5'
                },
                {
                    Name: 'CUSTOMERS.SPEC1',
                    Title: 'התמחותתת',
                    Id: '4:SPEC1'
                },
                {
                    Name: 'CUSTOMERS.SPEC6',
                    Title: 'מקצוע',
                    Id: '4:SPEC6'
                },
                {
                    Name: 'CUSTOMERS.SPEC9',
                    Title: 'פרמטר שלי',
                    Id: '4:SPEC9'
                }
            ]
        }
    ],
    Messages: []
};

export const MOCK_GET_MESSAGE_COLUMNS_RESPONSE = {
    FormName: 'AINVOICES',
    FormTitle: 'Sales Invoices',
    FormEnglishTitle: 'Sales Invoices',
    Columns: [
        {Name: 'IVNUM', Title: 'Invoice Number'},
        {Name: 'CUSTNAME', Title: 'Customer Name'},
        {Name: 'IVDATE', Title: 'Invoice Date'}
    ],
    ColumnTreeItems: [
        {
            FormName: 'AINVOICEITEMS',
            FormTitle: 'Invoice Items',
            FormEnglishTitle: 'Invoice Items',
            Columns: [
                {Name: 'PARTNAME', Title: 'Part Number'},
                {Name: 'QUANT', Title: 'Qty (Factory Units)'}
            ],
            ColumnTreeItems: []
        },
        {
            FormName: 'BINVOICEITEMS',
            FormTitle: 'BInvoice Items',
            FormEnglishTitle: 'BInvoice Items',
            Columns: [
                {Name: 'BPARTNAME', Title: 'b Part Number'},
                {Name: 'BQUANT', Title: 'b Qty (Factory Units)'}
            ],
            ColumnTreeItems: []
        }
    ]
};

export const SUBJECT_MAX_LENGTH = 68;
